export enum VehicleKindEnum {
  Car = '!MOTOR',
  Motor = 'MOTOR',
}
